import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import type { MasterControlWorkflowEntry } from "@/hooks/useMasterControl";

type MCWorkflowInspectorTableProps = {
  rows: MasterControlWorkflowEntry[];
  emptyMessage: string;
  showStalledInfo?: boolean;
  onSelect: (entry: MasterControlWorkflowEntry) => void;
};

const formatDuration = (seconds: number | null | undefined) => {
  if (!seconds || Number.isNaN(seconds)) return "—";
  if (seconds < 60) return `${seconds}s`;
  const minutes = Math.floor(seconds / 60);
  const remaining = seconds % 60;
  if (minutes < 60) return `${minutes}m ${remaining}s`;
  const hours = Math.floor(minutes / 60);
  const min = minutes % 60;
  return `${hours}h ${min}m`;
};

export function MCWorkflowInspectorTable({
  rows,
  emptyMessage,
  showStalledInfo,
  onSelect,
}: MCWorkflowInspectorTableProps) {
  return (
    <div className="overflow-x-auto rounded-2xl border border-border bg-background/60">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Workflow</TableHead>
            <TableHead>Agent</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Last event</TableHead>
            <TableHead>Runtime</TableHead>
            {showStalledInfo && <TableHead>Stalled for</TableHead>}
            <TableHead className="text-right">Pending actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.map((entry) => (
            <TableRow key={entry.workflow_id} className="cursor-pointer" onClick={() => onSelect(entry)}>
              <TableCell className="text-sm font-semibold text-foreground">{entry.workflow_id}</TableCell>
              <TableCell className="text-sm text-foreground/80">{entry.agent}</TableCell>
              <TableCell className="text-sm capitalize text-foreground/80">{entry.status}</TableCell>
              <TableCell className="text-sm text-foreground/80">
                {entry.last_event_at ? new Date(entry.last_event_at).toLocaleString() : "—"}
              </TableCell>
              <TableCell className="text-sm text-foreground/80">{formatDuration(entry.run_time_seconds)}</TableCell>
              {showStalledInfo && (
                <TableCell className="text-sm text-rose-300">{formatDuration(entry.stalled_for_seconds)}</TableCell>
              )}
              <TableCell className="text-right text-sm font-semibold text-foreground">{entry.pending_actions}</TableCell>
            </TableRow>
          ))}
          {!rows.length && (
            <TableRow>
              <TableCell colSpan={showStalledInfo ? 7 : 6} className="py-6 text-center text-sm text-muted-foreground">
                {emptyMessage}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
}

export default MCWorkflowInspectorTable;
